import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useCreateEditEntityTemplateDialog } from "./CreateEditEntityTemplateDialog.hooks.ts";
import { EntityTemplateRowViewModel, TemplateEntityType } from "../EntityTemplate.types.ts";
import { useTranslation } from "../../localization/useTranslation.ts";
import { isNullOrWhitespace } from "../../common/stringOperations.ts";
import EntityTemplateOption from "../EntityTemplateOption";

export interface CreateEditEntityTemplateDialogProps {
    onCloseDialog: () => void;
    onTemplateSaved: () => void;
    entityTemplateToEdit?: EntityTemplateRowViewModel;
    templateEntityType: TemplateEntityType;
}

function CreateEditEntityTemplateDialog(props: CreateEditEntityTemplateDialogProps) {
    const isEdit = props.entityTemplateToEdit;

    const { translateString } = useTranslation();
    const {
        saveModel,
        modelUpdater,
        onSaveClick,
        isSaving,
        showErrors,
        getHeader,
        choosesStandardTemplate,
        standardTemplates,
        standardTemplatesLoading,
        lockedStandardTemplateTexts,
        selectedStandardTemplateId,
    } = useCreateEditEntityTemplateDialog(props);

    return (
        <DotLegalDialog
            header={getHeader()}
            buttonOkText={isEdit ? translateString("save") : translateString("create")}
            onOkClick={onSaveClick}
            okButtonDisabled={isSaving}
            onDialogClose={props.onCloseDialog}
            open
            size="sm"
        >
            <Box sx={{ padding: 2, display: "flex", flexDirection: "column", width: choosesStandardTemplate ? "95%" : "100%" }}>
                <DotLegalTextField
                    label={translateString("name")}
                    value={saveModel.name}
                    onChange={modelUpdater.onNameChange}
                    errorText={showErrors && isNullOrWhitespace(saveModel.name) ? translateString("nameRequired") : undefined}
                    debounce={false}
                />

                <DotLegalTextField
                    label={translateString("description")}
                    value={saveModel.description ?? null}
                    onChange={modelUpdater.onDescriptionChange}
                    multiline
                    rows={4}
                    debounce={false}
                />

                {choosesStandardTemplate && (
                    <DotLegalSelect
                        options={standardTemplates}
                        onChange={modelUpdater.onStandardTemplateChange}
                        label={translateString("basedOnStandardTemplate")}
                        noOptionsLabel={translateString("noOptions")}
                        isLoading={standardTemplatesLoading}
                        toolTipText={translateString("basedOnStandardTemplateTooltip")}
                        disableClearable
                        selectedItem={selectedStandardTemplateId ?? null}
                        renderOptions={(option) => <EntityTemplateOption name={option.name} lockedText={lockedStandardTemplateTexts.get(option.id)} />}
                    />
                )}
            </Box>
        </DotLegalDialog>
    );
}

export default CreateEditEntityTemplateDialog;
